import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Container, Image, Menu } from "semantic-ui-react";

import logo from "resources/logo.png";

const NavbarDesktop = ({ leftItems, rightItems }) => (
  <Menu
    fixed="top"
    inverted
    style={{
      backgroundColor: "#eb4b2e",
      borderColor: "white",
      borderWidth: 0
    }}
  >
    <Container style={{ backgroundColor: "#eb4b2e" }}>
      {_.map(leftItems, item => (
        <Menu.Item
          style={{
            color: "white",
            fontSize: 25,
            fontWeight: "bold",
            borderColor: "white",
            borderWidth: 0
          }}
          {...item}
        />
      ))}
      <Menu.Menu position="right">
        {_.map(rightItems, item => (
          <Menu.Item style={{ color: "white" }} {...item} />
        ))}
      </Menu.Menu>
    </Container>
  </Menu>
);

NavbarDesktop.propTypes = {
  leftItems: PropTypes.arrayOf(PropTypes.object),
  rightItems: PropTypes.arrayOf(PropTypes.object)
};

export default NavbarDesktop;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarDesktop.js